<mat-drawer-container class="w-full h-full">
    <mat-drawer [class]="drawerAction === 'data-form' ? 'md:w-1/3 dark:bg-gray-900 sm:w-96' : 'sm:w-96 dark:bg-gray-900'"
        [class.fixed]="drawerAction === 'data-form' && isFixed"
        [autoFocus]="false"
        [mode]="drawerMode" [opened]="drawerOpened" position="end"
        (closed)="onDrawerClosed()"
        #innerDrawerInfoWindow>
        @switch (drawerAction) {
            @case ('help') {
                <div class="flex items-center justify-between m-4 mr-6 sm:my-4">
                    <div class="text-4xl font-extrabold tracking-tight leading-none flex flex-row items-center">
                        {{title}}
                    </div>
                    <div>
                        <button mat-icon-button (click)="closeSideDrawer()">
                            <mat-icon [svgIcon]="'heroicons_outline:x'"></mat-icon>
                        </button>
                    </div>
                </div>
                <div class="flex flex-col divide-y border-t border-b">
                    <div class=" m-4 mr-6 sm:my-4">
                        <div [innerHTML]="text"></div>
                    </div>
                </div>
            }
            @case ('data-form') {
                <app-data-form
                    [formUrl]="innerForm"
                    [formFields]="innerFormFields"
                    [dictionary]="innerDictionary"
                    [apiUrl]="innerEndpoint"
                    [idField]="idField"
                    [skipApi]="skipApi"
                    [model]="innerModel"
                    (submitForm)="onDrawerFormSubmit($event)"
                    (cancelForm)="onDrawerFormCancel()">
                </app-data-form>
            }
        }
    </mat-drawer>
    <mat-drawer-content class="flex flex-col h-screen">
        <div class="flex-1 overflow-y-auto overscroll-contain touch-auto md:min-h-screen md:h-full">
            <router-outlet class="md:min-h-screen md:h-full"></router-outlet>
        </div>
    </mat-drawer-content>
</mat-drawer-container>
